// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.AdvancedSettingDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import fetch from 'share/fetch/Izenda.Fetch';
import { isNil, isEmpty } from 'lodash/fp';

const ROOT_URL = 'advancedSetting/';

export default {
  BASE_PATH: ROOT_URL,
  /**
   * Load Performance
   * @param {type} tenantId
   * @returns {type}
   */
  loadPerformance(tenantId: string): any {
    const tenant = isEmpty(tenantId) ? '' : tenantId;

    return fetch(`${ROOT_URL}Performance/${tenant}`).get();
  },

  /**
   * Save Performance
   * @param {type} data
   * @returns {type}
   */
  savePerformance(data) {
    return fetch(`${ROOT_URL}Performance/`).post(data);
  },

  /**
   * Load other settings
   * @param {type} tenantId
   * @returns {type}
   */
  loadOther(tenantId) {
    const tenant = isEmpty(tenantId) ? '' : tenantId;

    return fetch(`${ROOT_URL}miscSetting/${tenant}`).get();
  },

  /**
   * Save other settings
   * @param {type} data
   * @returns {type}
   */
  saveOther(data) {
    return fetch(`${ROOT_URL}miscSetting/`).post(data);
  },

  /**
   * Get all categories
   * @param {String} tenantId
   * @returns {promise}
   */
  getAllCategories(tenantId) {
    return fetch(`${ROOT_URL}category/${tenantId}`).get();
  },

  /**
   * Save Categories
   * @param {type} data
   * @returns {type}
   */
  saveCategories(data) {
    return fetch(`${ROOT_URL}category/`).post(data);
  },

  /**
   * Delete Category
   * @param {type} data
   * @returns {type}
   */
  deleteCategory(id: string): any {
    return fetch(`${ROOT_URL}category/${id}`).delete();
  },

  /**
   * Get Tenant Security
   * @param {type} tenantId
   * @returns {type}
   */
  getTenantSecurity(tenantId: string): any {
    const tenant = isEmpty(tenantId) ? '' : tenantId;

    return fetch(`${ROOT_URL}security/${tenant}`).get();
  },

  /**
   * Save Tenant Security
   * @param {type} data
   * @returns {type}
   */
  saveTenantSecurity(data: any): any {
    return fetch(`${ROOT_URL}security/`).post(data);
  },

  /**
   * Get default image url
   * @returns {promise}
   */
  getDefaultImageUrl(tenantId: string): any {
    if (isNil(tenantId)) {
      return fetch(`${ROOT_URL}defaultImageUrl`).get();
    }
    return fetch(`${ROOT_URL}defaultImageUrl?tenantId=${tenantId}`).get();
  },

  /**
   * Save default image url
   * @returns {promise}
   */
  saveDefaultImageUrl(data: any): any {
    return fetch(`${ROOT_URL}defaultImageUrl`).post(data);
  },

  /**
   * Get default theme
   * @param {string} tenantId 
   */
  getDefaultTheme(tenantId: string) {
    const uri = isNil(tenantId) ? `${ROOT_URL}defaultTheme` : `${ROOT_URL}defaultTheme/${tenantId}`;
    return fetch(uri).get();
  },

  /**
   * Save default theme
   * @param {Object} data 
   */
  saveDefaultTheme(data: any) {
    return fetch(`${ROOT_URL}defaultTheme`).post(data);
  }
};



// WEBPACK FOOTER //
// ./ui/fetchers/Izenda.AdvancedSettingDataFetcher.js